
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-benefit/facility/[companyname]",
      function () {
        return require("private-next-pages/gangwon-benefit/facility/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-benefit/facility/[companyname]"])
      });
    }
  